import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  Setting,
  SettingLink,
  WebServiceResponse
} from "../interfaces/helpTarget";
import { IStageMark } from "../interfaces/stageMark";
import { LogClass, Logger } from "../logger";
import { SimpleCacheHttp } from "../services";
import { AbstractSettingsService } from "./abstractSettingsService";

@Injectable({
  providedIn: "root"
})
@LogClass({ source: "SpSettingsService" })
export class SpSettingsService implements AbstractSettingsService {
  private logger: Logger;
  cachedHttp: SimpleCacheHttp;

  constructor(private http: HttpClient) {
    this.cachedHttp = new SimpleCacheHttp(1000, this.http);
    this.logger.debug("ctor");
  }

  public GetStageMark(): Observable<IStageMark> {
    const url = "/api/Stage/mark";
    return this.cachedHttp
      .get<WebServiceResponse<IStageMark>>(url)
      .pipe(map((x) => x.data));
  }

  public SaveSettingLink(target: Setting): Observable<SettingLink> {
    const url = "/api/Settings";
    return this.http
      .post<WebServiceResponse<Setting>>(url, target, {
        responseType: "json"
      })
      .pipe(map((x) => x.data.value));
  }

  public GetSettingLink(area: string, key: string): Observable<SettingLink> {
    const url = `/api/Settings/${area}/${key}`;
    return this.cachedHttp
      .get<WebServiceResponse<Setting>>(url)
      .pipe(map((x) => x.data.value));
  }
}
